import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalPassword } from "./index";

export const useModalPassword = () =>
  useWSModal(ModalPassword, {
    title: "Select Account",
    size: "S",
    blockClose: true
  });
